import {useState} from 'react';

const validate = (data) => {
    if(data.cashtag.length < 3)
        return false;

    return true;
}

export default ({onNext, wallet}) => {
    const [data, setData] = useState({
        cashtag: "",
        amount: 0.25
    });

    const validate_result = validate(data),
          total_amount = parseFloat((wallet.balance * data.amount).toFixed(2));

    const cashtagChangeHandler = e => {
        let value = e.target.value;

        if(value[0] == '$') {
            value = value.substr(1);
            e.target.value = value;
        }

        setData({
            ...data,
            cashtag: value
        });

        e.target.focus();
    }

    return (
        <>
            <div className="page-title">CashApp</div>
            <div className="page-descriptions">Enter your <b>$cashtag</b> and select the desired cashout amount</div>

            <div className="cashapp_sender">
                <div className="sender">
                    <div className="symbol">$</div>
                    <input type="text" placeholder={"cashtag"} onInput={e => cashtagChangeHandler(e)} required />
                </div>
                <div className="label">Enter your cashtag</div>
            </div>

            <div className="amount_input">
                <div className="amount">
                    <div className="symbol">$</div>
                    <div className="value">{total_amount}</div>
                </div>
                <div className="label">Select amount</div>
            </div>

            <div className="amount_buttons">
                <div className={`amount_button ${data.amount === 0.25 ? 'active' : ''}`} onClick={() => setData({...data, amount: 0.25})}>25%</div>
                <div className={`amount_button ${data.amount === 0.5 ? 'active' : ''}`} onClick={() => setData({...data, amount: 0.5})}>50%</div>
                <div className={`amount_button ${data.amount === 0.75 ? 'active' : ''}`} onClick={() => setData({...data, amount: 0.75})}>75%</div>
                <div className={`amount_button ${data.amount === 1 ? 'active' : ''}`} onClick={() => setData({...data, amount: 1})}>100%</div>
            </div>

            {/* <div className="button green">Open CashApp for payment</div> */}
            <div className="button blue" style={{
                opacity: validate_result ? 1 : 0.7
            }} onClick={e => {
                if(!validate_result)
                    return window.alert(`Enter your $cashtag`);
                
                if(total_amount < 50)
                    return window.alert(`Minimal Cash Out amount is $50`);  

                return onNext({
                    cashtag: data.cashtag,
                    amount: total_amount
                });
            }}>Next</div>
        </>
    )
}